import {CardCvcElement, CardExpiryElement, CardNumberElement, Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import {Stripe, loadStripe} from '@stripe/stripe-js';
import _ from 'lodash';
import {Component} from 'react';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {RootState} from 'store/reducers';
import errorMessages from 'utils/errorMessages';
import {stripeLiveKey} from '../../config';
import * as cardAction from '../../store/actions/payment.action';
import {getPromoDetails} from '../../store/actions/promoCode.action';
import * as types from '../../store/actions/types';
import store from '../../store/store';
import {fetchCurrentLeadDetail, getQueryValue, handleToast, loadMyDetail, localStorageKeyValue, queryParams, removeLocalStorageValue, updateUser, userInterested} from '../../utils/handler';
import {propsTypes, stateType} from '../types/payments';
const stripePromise = loadStripe(stripeLiveKey);
class Payment extends Component<propsTypes, stateType> {
  constructor(props: propsTypes) {
    super(props);
    this.state = {
      loadingApplyBTN: false,
      nameOnCard: '',
      loadingBTN: false,
      cardError: '',
      cardDateError: '',
      cvvDateError: '',
      isFormSubmitted: false,
      cardType: '',
      acceptTerms: false,
      acceptHire: false,
      phoneValidationError: '',
      showPromoCode: false,
      promoCode: '',
      promoCodeError: 'Promo code is required',
      codeApplied: false,
      validCode: false,
      offerPercent: 0,
      showOnlyPromo: false,
      leadUID: '',
    };
  }

  login = () => {};
  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name: any = e.target.name;
    let value: string = e.target.value;
    let obj: any = { [name]: value, codeApplied: false };
    this.setState(obj);
  };
  async componentDidMount() {
    let leadUID = this.props.leadDetails?.UID || getQueryValue(queryParams.leadUID) || '';
    if (!leadUID) {
      let lead = await fetchCurrentLeadDetail();
      if (lead) {
        leadUID = lead.UID;
      }
    }
    let promoCode = getQueryValue(localStorageKeyValue.promoCode);
    if (!promoCode) promoCode = localStorage.getItem(localStorageKeyValue.promoCode);

    if (promoCode) {
      this.setState({ promoCode, showPromoCode: true });
    }
    let myProfile = this.props?.myProfile;
    if (!myProfile?.registrarUID && myProfile?.userInterested === userInterested.buy) {
      this.setState({ showOnlyPromo: true });
    }
    this.setState({ leadUID, nameOnCard: this.props.myProfile?.name || '', phone: this.props.myProfile?.phone || '' });
  }
  // componentWillReceiveProps(nextProps: Readonly<propsTypes>): void {
  //   console.log(nextProps.leadDetails)
  //   if (nextProps.leadDetails.UID && !this.state.leadUID) {
  //     this.setState({leadUID: nextProps.leadDetails.UID})
  //   }
  // }

  isValidCard = () => {
    if (this.state.phone && !isValidPhoneNumber(this.state.phone)) {
      this.setState({ phoneValidationError: 'Invalid phone number' });
      return false;
    }
    if (!this.state.acceptTerms) {
      return false;
    }
    return true;
  };
  phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      this.setState({ phoneValidationError: '' });
    }
    if (this.state.isFormSubmitted && value && !isValidPhoneNumber(value)) {
      this.setState({ phoneValidationError: 'Invalid phone number' });
    }
    this.setState({ phone: value });
  };
  applyCode = () => {
    this.setState({ loadingApplyBTN: true });
    getPromoDetails(this.state.promoCode).then((res) => {
      this.setState({ loadingApplyBTN: false, codeApplied: true });
      if (!_.isEmpty(res)) {
        this.setState({ validCode: true, offerPercent: res.offerPercent });
      } else {
        this.setState({ validCode: false, offerPercent: 0 });
      }
    });
  };
  handleSubmit = async (event: any, stripe?: Stripe | null, elements?: any) => {
    event.preventDefault();
    // let {promoCode, codeApplied} = {...this.state};
    try {
      this.setState({ isFormSubmitted: true });
      if (this.state.acceptTerms && this.state.acceptHire && stripe) {
        this.proceedPayment(stripe, elements);
      }
    } catch (error) {
      console.error(error);
      this.stopBtnLoader(false);
      toast.error('Somthing went wrong');
    }
  };

  stopBtnLoader = (action) => {
    this.props.updatePageLoader(action);
    this.setState({ loadingBTN: action });
  };

  proceedPayment = async (stripe: Stripe, elements?: any) => {
    if (!this.state.acceptTerms || !this.state.acceptHire) {
      return;
    }
    this.setState({ loadingBTN: true });
    let { promoCode, leadUID, showOnlyPromo } = { ...this.state };
    if (!leadUID) {
      loadMyDetail();
      handleToast({ message: errorMessages.leadDetailNotLoaded }, 'error');
      return true;
    }
    this.setState({ isFormSubmitted: true });
    if (promoCode || showOnlyPromo) {
      if (promoCode) {
        this.stopBtnLoader(true);
        this.setState({ codeApplied: true });
        let payload = {
          code: this.state.promoCode,
          leadUID,
        };
        let paymentResult = await cardAction.payUsingPromoCode(payload);
        if (paymentResult) {
          removeLocalStorageValue(localStorageKeyValue.promoCode);
          // if (this.state.phone) {
          updateUser('', this.state.phone, this.props.myProfile, this.state.nameOnCard);
          // }
          this.props.paymentSuccess(paymentResult);
        } else {
          this.setState({ validCode: false });
        }
      } else {
        handleToast({ message: errorMessages.invalidPromo }, 'error');
      }
      this.stopBtnLoader(false);
    } else {
      let billing_details: { name?: string; email?: string; phone?: string } = {};
      if (this.state.nameOnCard || this.props.myProfile?.name) {
        billing_details.name = this.state.nameOnCard || this.props.myProfile?.name;
      }
      if (this.props.myProfile?.email) {
        billing_details.email = this.props.myProfile?.email;
      }
      if (this.props.myProfile?.phone || this.state.phone) {
        billing_details.phone = this.state.phone || this.props.myProfile?.phone;
      }
      // closeId: this.props.leadDetails.closeUID,
      // leadUID: this.props.leadDetails.leadUID

      // if (this.state.phone) {
      updateUser('', this.state.phone, this.props.myProfile, this.state.nameOnCard);
      // }
      this.isValidCard();
      stripe
        .createPaymentMethod({
          type: 'card',
          card: elements.getElement(CardNumberElement),
          billing_details,
        })
        .then(async (response: any) => {
          this.stopBtnLoader(true);
          const { error, paymentMethod } = response;
          if (!error && this.isValidCard()) {
            let paymentResponse = await cardAction.paymentStripe({
              paymentID: paymentMethod.id,
              amountPaid: 19.95,
              leadUID: this.props.leadDetails.UID,
            });
            if (paymentResponse) {
              if (paymentResponse.clientSecret) {
                stripe
                  .confirmCardPayment(paymentResponse.clientSecret)
                  .then((result: any) => {
                    if (result.error) {
                      this.stopBtnLoader(false);

                      // Show `result.error.message` in payment form
                      toast.error(result.error.message);
                    } else {
                      // The card action has been handled
                      // The PaymentIntent can be confirmed again on the server
                      cardAction.stripeVerification({ leadUID: this.props.leadDetails.UID, id: result.paymentIntent.id }).then((response) => {
                        if (response) {
                          this.props.paymentSuccess(response);
                        }
                        this.stopBtnLoader(false);
                      });
                    }
                  })
                  .catch((e: React.ChangeEvent<HTMLInputElement>) => {
                    console.error(e);
                    this.stopBtnLoader(false);
                  });
              } else {
                toast.success('Success! The charge has been approved.');
                this.props.paymentSuccess(paymentResponse);
                this.stopBtnLoader(false);
              }
            } else {
              this.stopBtnLoader(false);
            }
          } else {
            toast.error(error && error.message);
            this.stopBtnLoader(false);
          }
        });
    }
  };

  render() {
    let { nameOnCard = '', showOnlyPromo = false, acceptHire = false, loadingApplyBTN = false, loadingBTN = false, cardError = '', cardDateError = '', cvvDateError = '', isFormSubmitted = false, cardType = '', offerPercent = false, acceptTerms = false, codeApplied = false, validCode = false, phoneValidationError, showPromoCode, promoCode } = { ...this.state };
    return (
      <div className="mt-2 f-bold row">
        <Elements stripe={stripePromise}>
          <ElementsConsumer>
            {({ stripe, elements }) => (
              <>
                <form noValidate onSubmit={(e) => this.handleSubmit(e, stripe, elements)} className={'col-12 ' + (isFormSubmitted ? ' was-validated' : '')}>
                  {!showOnlyPromo ? (
                    <div>
                      <div className={'form-group  col-12 '}>
                        <label>Card number</label>
                        <CardNumberElement
                          id="card-input"
                          onChange={(object) => {
                            this.setState({ cardError: object.error ? object.error.message : '', cardType: object.brand === 'unknown' ? '' : object.brand });
                          }}
                          className={'form-control saw-input card-input'}
                        />
                        <label className="input-icon">{cardType}</label>
                        <div className="form-error-message text-danger">{cardError}</div>
                      </div>
                      <div className="form-group form-row col-12">
                        <div className="form-group  col-6">
                          <label>Expires</label>
                          <CardExpiryElement
                            id="card-Expiry"
                            onChange={(object) => {
                              this.setState({ cardDateError: object.error ? object.error.message : '' });
                            }}
                            className="form-control saw-input card-input"
                          />
                          <div className="form-error-message text-danger">{cardDateError}</div>
                        </div>

                        <div className="form-group   col-6">
                          <label>CVV</label>
                          <CardCvcElement
                            id="card-cvc"
                            onChange={(object) => {
                              this.setState({ cvvDateError: object.error ? object.error.message : '' });
                            }}
                            className={'form-control saw-input card-input'}
                          />
                          <div className="form-error-message text-danger">{cvvDateError}</div>
                        </div>
                      </div>
                      <div className="form-group form-row col-12">
                        <div className="form-group col-sm-6">
                          <label>Name on the Card</label>
                          <input autoFocus autoComplete="off" type="text" placeholder="Name on Card" className="form-control no-validate" name="nameOnCard" value={nameOnCard} onChange={this.handleChange} required />
                          <div className="invalid-feedback">Please fill out name printed in card or Account holder name</div>
                        </div>
                        <div className="form-group  col-sm-6">
                          <label>Phone Number</label>
                          <PhoneInput international defaultCountry={this.props.localCountryStr} placeholder="Enter phone number" value={this.state.phone} name="phone" onChange={(data: any) => this.phoneNumberChange(data)} className="form-control " />
                          {phoneValidationError !== '' && <div className="text-danger fs-13">{phoneValidationError}</div>}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {showPromoCode || showOnlyPromo ? (
                    <div className=" ml-2 mb-3">
                      <div className="d-sm-flex justify-content-center align-items-center">
                        <input type="text" value={promoCode} name="promoCode" placeholder="Enter promo code..." className={'form-control mt-2 ' + (codeApplied && (!validCode || promoCode === '') ? ' is-invalid ' : '')} onChange={this.handleChange} required />
                        {codeApplied && validCode ? (
                          <button
                            className="btn text-nowrap btn-outline-secondary btn-auto mt-2 ml-sm-2 mx-auto"
                            type="button"
                            onClick={(e) => {
                              this.setState({
                                validCode: false,
                                codeApplied: false,
                                offerPercent: 0,
                                promoCode: '',
                              });
                            }}
                          >
                            Remove Promo Code
                          </button>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center flex-column flex-sm-row">
                            <button
                              disabled={this.state.promoCode.length <= 4 ? true : false}
                              className="btn text-nowrap btn btn-grad btn-auto ml-sm-2 mt-2"
                              type="button"
                              onClick={() => {
                                this.applyCode();
                              }}
                            >
                              {loadingApplyBTN ? <i className="fas fa fa-spinner fa-pulse fa-sm" /> : ''} Apply Code
                            </button>
                            <button
                              className=" btn btn-outline-secondary btn-auto mt-2"
                              type="button"
                              onClick={() =>
                                this.setState({
                                  validCode: false,
                                  codeApplied: false,
                                  offerPercent: 0,
                                  promoCode: '',
                                  showPromoCode: !this.state.showPromoCode,
                                })
                              }
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="row justify-content-center">
                      <button className=" btn fs-18 btn-grad-outline ml-sm-3" type="button" onClick={() => this.setState({ showPromoCode: !this.state.showPromoCode })}>
                        Add Promo Code
                      </button>
                    </div>
                  )}
                  {!loadingBTN && codeApplied ? <div className="text-center">{!validCode || (showOnlyPromo && !promoCode) ? <span className="text-danger">{errorMessages.invalidPromo} </span> : <span className="text-success">{offerPercent}% discounted </span>}</div> : null}
                  {showOnlyPromo ? <p className="text-danger fs-12 ml-2 ">Note: Check your registered E-mail for a promo code.</p> : null}
                  <hr className={showOnlyPromo ? 'mt-1' : ''} />
                  <div className="form-check-label ml-1 fs-14 col-12">
                    <input type="checkbox" name="acceptTerms" defaultChecked={acceptTerms} onClick={() => this.setState({ acceptTerms: !acceptTerms })} className="form-check-input saw-check-box" id="adventure_id" required />
                    <div className="">
                      I have read and accept the{' '}
                      <span 
                        className="theme-color hover-u"
                        // onClick={() => store.dispatch({ type: types.TERMS_AND_SERVICE, payload: true })}
                        onClick={() => window.open("https://saw.com/terms-of-service#buyer-brokerage-services", "_blank", "noopener,noreferrer")}
                      >
                        Privacy Policy and Terms of Service
                      </span>{' '}
                    </div>
                    <div className="invalid-feedback">Please Accept Privacy Policy and Terms of Service</div>
                  </div>
                  <div className="form-check-label ml-1 fs-14 col-12">
                    <input type="checkbox" name="acceptHire" defaultChecked={acceptHire} onClick={() => this.setState({ acceptHire: !acceptHire })} className="form-check-input saw-check-box" id="adventure_id" required />
                    <div className="">
                      I am hiring <span className="theme-color">Saw.com</span>, to advise and help purchase a domain that may not be available at my desired price.
                    </div>
                    <div className="invalid-feedback">Kindly read the disclaimer before you progress further</div>
                  </div>

                  <div className="row mt-1 justify-content-center ">
                    <button disabled={!stripe || loadingBTN} className=" btn fs-18 btn-grad" type="submit" onClick={(e) => this.handleSubmit(e, stripe, elements)}>
                      {loadingBTN ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : 'Hire A Broker'}
                    </button>
                  </div>
                </form>
              </>
            )}
          </ElementsConsumer>
        </Elements>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  leadDetails: state.leadReducer.leadDetails,
  myProfile: state.userReducer.myProfile,
  localCountryStr: state.mainReducer.localCountryStr,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updatePageLoader: (action) => dispatch({ type: types.PAGE_LOADER, payload: action }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
